import { DEVICE } from '../../constants';

const mobileCoordinates = [
  { x: 216, y: 38 },
  { x: 103, y: 132 },
  { x: 176, y: 244 },
  { x: 43, y: 349 },
  { x: 75, y: 493 },
  { x: 203, y: 588 },
  { x: 173, y: 730 },
  { x: 103, y: 856 },
  { x: 176, y: 980 },
  { x: 117, y: 1116 },
  { x: 249, y: 1228 },
  { x: 204, y: 1381 },
];

const padCoordinates = [
  { x: 59, y: 234 },
  { x: 199, y: 376 },
  { x: 377, y: 266 },
  { x: 536, y: 495 },
  { x: 755, y: 419 },
  { x: 895, y: 242 },
  { x: 1106, y: 294 },
  { x: 1298, y: 407 },
  { x: 1473, y: 277 },
  { x: 1683, y: 365 },
  { x: 1851, y: 163 },
];

const pcCoordinates = [
  [{ x: 26.5, y: 320 }, { x: 133.5, y: 202.5 }, { x: 220.5, y: 172.1 }, { x: 287.6, y: 229 }],
  [{ x: 287.6, y: 229 }, { x: 388.2, y: 314.3 }, { x: 262.7, y: 508 }, { x: 311.5, y: 603 }],
  [{ x: 311.5, y: 603 }, { x: 360.2, y: 698 }, { x: 517.5, y: 705 }, { x: 599.5, y: 628.1 }],
  [{ x: 599.5, y: 628.1 }, { x: 681.5, y: 550.3 }, { x: 636.0, y: 447.3 }, { x: 582.5, y: 394.1 }],
  [{ x: 582.5, y: 394.1 }, { x: 529, y: 341 }, { x: 449, y: 314 }, { x: 472, y: 162 }],
  [{ x: 472, y: 162 }, { x: 495, y: 10 }, { x: 907, y: 63 }, { x: 868, y: 260 }],
  [{ x: 868, y: 260 }, { x: 829, y: 458 }, { x: 718.2, y: 632.4 }, { x: 856.1, y: 674 }],
  [{ x: 856.1, y: 674 }, { x: 994, y: 715.5 }, { x: 1054, y: 704 }, { x: 1109.3, y: 603 }],
  [{ x: 1109.3, y: 603 }, { x: 1164, y: 502 }, { x: 974, y: 376 }, { x: 1084.7, y: 282 }],
  [{ x: 1084.7, y: 282 }, { x: 1167.5, y: 211.8 }, { x: 1261.1, y: 272.2 }, { x: 1294, y: 285 }],
];

const coordinatesObj = {
  [DEVICE.MOBILE]: mobileCoordinates,
  [DEVICE.PAD]: padCoordinates,
  [DEVICE.PC]: pcCoordinates,
};

const computedCoordinates = (coordinate, obj) => (
  { x: coordinate.x + (obj.x || 0), y: coordinate.y + (obj.y || 0) }
);

export const getCoordinates = (num, device) => {
  const defaultCo = coordinatesObj[device];
  if (device === DEVICE.PC) return defaultCo;
  const coordinates = [];
  const n = Math.ceil(num / defaultCo.length);
  for (let i = 0; i < n; i += 1) {
    let coor = {};
    if (device === DEVICE.MOBILE) {
      const lastY = coordinates.length
        ? coordinates[coordinates.length - 1].y + 120
        : 0;
      coor = { x: 0, y: lastY };
    } else if (device === DEVICE.PAD) {
      const lastX = coordinates.length
        ? coordinates[coordinates.length - 1].x + 200
        : 0;
      coor = { x: lastX, y: 0 };
    }
    coordinates.push(...(defaultCo.map(item => computedCoordinates(item, coor))));
  }
  return coordinates.slice(0, num);
};
